import actionTypes from '../constants/action-types';

const blockTemplates = (state = [], action) => {
  if (action.type === actionTypes.SET_BLOCK_TEMPLATES) {
    return action.payload.blockTemplates;
  }

  return state;
};

export default blockTemplates;
